import React from 'react'


export const CorreoCantidadMinima = (listaProductos) => {
    if (listaProductos && Array.isArray(listaProductos.listaProductos)) {
        const arrayProductos = listaProductos.listaProductos;

        return (
            <div>
                <p>Los siguientes productos llegaron a la cantidad mínima en inventario:</p>

                <table border="1" cellPadding="5" cellSpacing="0" style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                        <tr>
                            <th style={{ width: '25px', backgroundColor: '#bee9fc', padding: '8px', textAlign: 'left' }}>Código Producto</th>
                            <th style={{ width: '200px', backgroundColor: '#bee9fc', padding: '8px', textAlign: 'left' }}>Nombre Producto</th>
                            <th style={{ width: '200px', backgroundColor: '#bee9fc', padding: '8px', textAlign: 'left' }}>Descripción</th>
                            <th style={{ width: '28px', backgroundColor: '#bee9fc', padding: '8px', textAlign: 'center' }}>Inventario Actual</th>
                            <th style={{ width: '28px', backgroundColor: '#bee9fc', padding: '8px', textAlign: 'center' }}>Mínimo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {arrayProductos.map((producto, index) => (
                            <tr key={index}>
                                <td style={{ padding: '8px', textAlign: 'left' }}>{producto.CodigoProducto}</td>
                                <td style={{ padding: '8px', textAlign: 'left' }}>{producto.NombreProducto}</td>
                                <td style={{ padding: '8px', textAlign: 'left' }}>{producto.DescripcionProducto}</td>
                                <td 
                                    style={{
                                        padding: '8px', 
                                        textAlign: 'center', 
                                        color: producto.InventarioActual <= 0 ? 'red' : 'black', 
                                        fontWeight: producto.InventarioActual <= 0 ? 'bold' : 'normal'
                                    }}
                                >
                                    {producto.InventarioActual}
                                </td>
                                <td style={{ padding: '8px', textAlign: 'center' }}>{producto.Minimo}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <br />
            </div>
        );
    } else {
        console.error("No se proporcionó una lista de productos válida.");
        return null;
    }
};
